module.exports = __webpack_public_path__ + "img/sy.e2b99b8e.png";